import { useToast } from "@agney/ir-toast";
import {
  IonAlert,
  IonButton,
  IonCol,
  IonIcon,
  IonItem,
  IonToggle,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import Call from "../../../components/Shared/Call/call";
import Sms from "../../../components/Shared/Sms/sms";
import { CONSTANTS } from "../../../constants";
import { utilService } from "../../../services";
import {
  BedDataObject,
  BedStatusApiResponse,
  ProcessedBedsData,
  setAssignStatusApiRequest,
} from "../UnitBedsDataModel";
import { UnitBedsService } from "../UnitBedsService";
import BedAssignPopup from "./BedAssignPopup";
import { chatbubbleEllipsesOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import { smsService } from "../../../components/Shared/Sms/Sms.service";
import { useTranslation } from "react-i18next";



interface propsInterface {
  bedData: BedDataObject;
  setBedsList: Function;
  updateBedList: Function;
  unitId?: any;
}
const BedCard: React.FunctionComponent<propsInterface> = (
  props: propsInterface
) => {
  const Toast = useToast();
const { t } = useTranslation("patients");
  

  const [showBedAssignModal, setShowBedAssignModal]: [boolean, Function] =
    useState(false);
  const [modalData, setModalData] = useState({
    patientName: "",
    assignedStatus: "",
  });
  const [isShowAlert, setIsShowAlert] = useState(false);

  const [bedId, setBedId]: any = useState([]);
  const [assignedStatus, setAssignedStatus]: any = useState([]);

  useEffect(() => {
    setBedId(props.bedData.id);
    setAssignedStatus(props.bedData.assigned_status);
  }, []);

  const showErrorToast = (bedsData: any) => {
    const currentBedData = bedsData.find((item: any) => item.id === bedId);
    if (currentBedData.assigned_status === assignedStatus) {
      Toast.error(CONSTANTS.MESSAGES.PATIENT_ASSIGN_ERROR);
    }
    setAssignedStatus(currentBedData.assigned_status);
  };

  const assignPatient = async (isPrimaryMd: boolean) => {
    setShowBedAssignModal(false);
    const currentDate = new Date();
    const params: setAssignStatusApiRequest = {
      pid: +props.bedData.details.pid,
      status: props.bedData.assigned_status === 1 ? false : true,
      unit_id: +UnitBedsService.getUnitId(),
      is_primary_md:
        isPrimaryMd === true ? isPrimaryMd : props.bedData.is_primary_md,
      hour: currentDate.getHours(),
      minute: currentDate.getMinutes(),
      date: `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1
      }-${currentDate.getDate()}`,
      reg_code: utilService.getNetwork(),
    };
    const setAssignedResponse: ProcessedBedsData =
      await UnitBedsService.setAssignedStatus(params);
    if (setAssignedResponse.isSuccess) {
      props.setBedsList(setAssignedResponse);
      showErrorToast(setAssignedResponse.bedsData);
     Toast.success(
  t("assignSuccess", {
    action:
      props.bedData.assigned_status === 1
        ? t("unassigned")
        : t("assigned"),
  })
);
    } else if (setAssignedResponse.isSuccess === false) {
      Toast.error(setAssignedResponse.message);
    }
  };

  const toggleBedActiveness = async () => {
    props.bedData.is_active = !props.bedData.is_active;
    const params = {
      bid: props.bedData.id,
    };
    const setBedStatusResponse: BedStatusApiResponse =
      await UnitBedsService.setBedStatus(params);
    if (setBedStatusResponse.isSuccess) {
      setIsShowAlert(false);
    } else {
      props.bedData.is_active = !props.bedData.is_active;
      Toast.error(setBedStatusResponse.message);
    }
    const newBedData = { ...props.bedData, is_active: props.bedData.is_active };
    props.updateBedList(newBedData);
  };

  const showAssignModal = () => {
    setModalData({
      patientName: props.bedData.details.patient_name,
      assignedStatus:
        props.bedData.assigned_status === 1 ? "assigned" : "unAssigned",
    });
    setShowBedAssignModal(true);
  };

  const getBedStatusColor = () => {
    if (props.bedData.assigned_status === 1) {
      return "bed-assigned";
    } else if (props.bedData.assigned_status === 2) {
      return "bed-assigned-to-others";
    } else if (props.bedData.assigned_status === 3) {
      return "bed-unassigned";
    }
  };

  const setDataToCall = () => {
    return {
      callTo: "patient",
      contactNumber: props.bedData.details.contact_details[0].number,
      name: props.bedData.details.patient_name,
    };
  };

  const history = useHistory();

  async function fetchDoctorInfo(params: any) {
    const respDoctorListResult: any = await smsService.getDoctorInformation(
      params
    );
    if (respDoctorListResult.isSuccess) {
      return respDoctorListResult.result;
      // if (respDoctorListResult.result) {
      //   checkSecondaryNumberExists(respDoctorListResult.result.userData);
      // }
    } else {
      console.log("error");
      smsService.handleErrorResponse();
    }
  }

  const handleSendMessage = async () => {
    const paramsDoctorInfo = {
      guid: props?.bedData?.nurse_details?.guid,
      reg_code: utilService.getNetwork(),
    };
    const result:any = await fetchDoctorInfo(paramsDoctorInfo);
    result.userData.profilePic = result?.userData?.image
    history.push({
      pathname: "/client/messages",
      state: {
        selectedDoctorData: [result?.userData],
        mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
        isFullscreen: true,
        pid:props?.bedData?.details?.pid,
        unit_id:props?.unitId,
      },
    });
  };

  return (
    <IonCol className="base-column mb-2" size="12" size-lg="3">
      <div className="bed-card-container">
        <div className="bed-title-container">
          <div className={`bed-title-inner-container ${getBedStatusColor()}`}>
            {utilService.checkUserRole("Doctor") && (
              <IonButton
                className={`button btn-curved w-100 ${
                  props?.bedData?.details?.patient_name
                    ? "border-color-active"
                    : "border-default"
                }`}
                onClick={() => showAssignModal()}
                disabled={!props.bedData.details.patient_name}
              >
                {props.bedData.assigned_status === 1 ? t("unassign") : t("assign")}
              </IonButton>
            )}
            <div className="bed-title">{props.bedData.details.bed_number}</div>
            {props.bedData.details.pid === "" &&
              utilService.checkUserRole("Charge Nurse") && (
                <IonItem className="toggle" lines="none">
                  <IonToggle
                    className="bed-card-toggle"
                    checked={props.bedData.is_active}
                    onIonChange={() => {
                      setIsShowAlert(true);
                    }}
                  />
                </IonItem>
              )}
          </div>
        </div>
        <div className="bed-content-container">
          {!props.bedData.is_active && <div className="content-disabled"></div>}
          <div className="patient-details-container">
            <div className="patient-details">
              <div className="name">{props.bedData.details.patient_name}</div>
              <div className="label">{t("patient")}</div>
            </div>
            {props.bedData.details?.contact_details[0]?.number &&
              props.bedData?.details?.patient_name && (
                <Call
                  selectedDoctorGuid=""
                  dataFromParent={setDataToCall()}
                  isAssignedNumber={true}
                ></Call>
              )}
          </div>
          <div className="nurse-details-container">
            <div className="nurse-details">
              <div className="name">{props.bedData.nurse_details.name}</div>
              <div className="label">{t("nurse")}</div>
            </div>
            {props.bedData?.nurse_details?.guid && (
              <div className="nurse-icon-wrapper">
                <div className="sms-div" onClick={() => handleSendMessage()} style={{color:"#098689"}}>
                  {/* <Sms
                    selectedDoctorGuid={props.bedData.nurse_details.guid}
                    pid={props.bedData.details.pid}
                    isAssignedNumber={true}
                    unitId={props.unitId}
                  ></Sms> */}
                  <IonIcon icon={chatbubbleEllipsesOutline} />
                </div>
                <div className="call-div">
                  <Call
                    selectedDoctorGuid={props.bedData.nurse_details.guid}
                  ></Call>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showBedAssignModal && (
        <BedAssignPopup
          showBedAssignModal={showBedAssignModal}
          handleClose={setShowBedAssignModal}
          modalData={modalData}
          assignPatient={assignPatient}
        />
      )}
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
header={t("confirmation")}
      message={t("bedToggleConfirm", {
  action: props.bedData.is_active
    ? t("deactivate")
    : t("activate"),
})}
      buttons={[
  {
    text: t("no"),
    role: "cancel",
    cssClass: "secondary",
  },
  {
    text: t("ok"),
    handler: () => {
      toggleBedActiveness();
    },
  },
]}
      />
    </IonCol>
  );
};

export default BedCard;
